export default __webpack_public_path__ + "static/media/pot3-big.55e640eb.jpg";